(() => {
  const SEL_NAV = ".site-nav__icons";
  const SEL_COUNTRY =
    ".ht-tms__duo-selector,[class*='ht-tms__duo-selector']";
  const SEL_WISHLIST =
    ".Vtl_WishlistHeaderWrapper,[class*='WishlistHeaderWrapper'],.Vtl_WishlistHeader";
  const SEL_ACCOUNT = "a[href*='/account']";
  const SEL_CART =
    "toggle-cart,[data-drawer*='cart'],a[href*='/cart'],a[href='#cart']";

  let scheduled = false;

  const scheduleFix = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      fix();
    });
  };

  const findTargetNav = () => {
    const navs = [...document.querySelectorAll(SEL_NAV)];
    return (
      navs.find(
        (n) => n.querySelector(SEL_COUNTRY) && n.querySelector(SEL_WISHLIST)
      ) || null
    );
  };

  const fix = () => {
    const nav = findTargetNav();
    if (!nav) return;

    const country = nav.querySelector(SEL_COUNTRY);
    const wishlist =
      nav.querySelector(".Vtl_WishlistHeaderWrapper") ||
      nav.querySelector(SEL_WISHLIST);

    if (!country || !wishlist) return;

    // Nur wenn nötig anfassen (verhindert Observer-Loop)
    if (country.nextElementSibling !== wishlist) country.after(wishlist);

    const account = nav.querySelector(SEL_ACCOUNT);
    if (account && wishlist.nextElementSibling !== account)
      wishlist.after(account);

    const cart = nav.querySelector(SEL_CART);
    if (cart && cart.parentElement === nav && nav.lastElementChild !== cart)
      nav.append(cart);
  };

  const boot = () => {
    scheduleFix();

    // Späte Injects: begrenzt
    let i = 0;
    const t = setInterval(() => {
      scheduleFix();
      if (++i > 25) clearInterval(t); // ~5s
    }, 200);

    // Observer gedrosselt
    const obs = new MutationObserver(scheduleFix);
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.addEventListener("pageshow", boot);
  document.addEventListener("shopify:section:load", boot);
})();
